import { Http } from '@samknows/utils';
import router from '@/common/router';

/**
 * Handle errors and token expired for this app specific user flow
 * 403 would be triggered by lack of permissions
 * 401 will be triggered by the API Gateway when the user is not authenticated
 */
export function setupHttp(): void {
  Http.registerCallbacks({
    handleResponseError: (response: Response) => {
      if (response.status === 401) {
        // Redirect to validate session so user gets redirected to the right place if session is not valid anymore
        router.push('/volunteers/validate-session');
        return;
      }
      return Promise.resolve();
    },
    handleTokenExpired: async () => {
      // Do nothing - handle token expired triggers on 401 and 403 but we need to handle those cases separately - see handleResponseError
      return Promise.resolve();
    }
  });
}
